/**
 * Môi trường máy chủ đang phục vụ trang — đọc từ `/api/health`, tức biến
 * `ENVIRONMENT` của Worker.
 *
 * Production và bản đào tạo (hisensebutton-training.toankhontech.com) chạy CÙNG
 * một bản dựng web; chỉ Worker khác nhau. Gắn cờ lúc build thì hai nơi phải có
 * hai bản dựng, và bản dựng nhầm chỗ sẽ không ai nhận ra. Hỏi máy chủ thì không
 * thể nhầm: dải báo đi theo đúng cơ sở dữ liệu mà trang đang ghi vào.
 */
export interface HealthEnvironment {
  environment?: string;
}

/** `staging` trong wrangler.toml là bản đào tạo: dữ liệu mẫu, người dùng thử thoải mái. */
export function isTrainingEnvironment(health: HealthEnvironment | null | undefined): boolean {
  return health?.environment === "staging";
}
